import { Group, Path, Segment } from "paper/dist/paper-core";
import { BORDER_COLOR, CANVAS_CENTER } from "../../constants";

const COLLAR_POINT = 78;
const TRAPEZIUS = 66;
const SUPRASTERNAL_NOTCH = 68;
const SHOULDER = 71;

export default class Shirt extends Group {
  constructor() {
    const rightShoulder = new Path({
      segments: [
        [CANVAS_CENTER + 15, TRAPEZIUS],
        [CANVAS_CENTER + 13, TRAPEZIUS - 6],
        new Segment({
          point: [CANVAS_CENTER, SUPRASTERNAL_NOTCH],
          handleIn: [5, 0],
          handleOut: [2, 0],
        }),
        [CANVAS_CENTER + 7, COLLAR_POINT],
        [CANVAS_CENTER + 15, TRAPEZIUS],
        [CANVAS_CENTER + 27, SHOULDER],
      ],
      strokeColor: BORDER_COLOR,
      strokeWidth: 1,
      closed: false,
    });

    const leftShoulder = new Path({
      segments: [
        [CANVAS_CENTER - 15, TRAPEZIUS],
        [CANVAS_CENTER - 12, TRAPEZIUS - 6],
        new Segment({
          point: [CANVAS_CENTER, SUPRASTERNAL_NOTCH],
          handleIn: [-5, 0],
          handleOut: [-2, 0],
        }),
        [CANVAS_CENTER - 7, COLLAR_POINT],
        [CANVAS_CENTER - 15, TRAPEZIUS],
        [CANVAS_CENTER - 27, SHOULDER],
      ],
      strokeColor: BORDER_COLOR,
      strokeWidth: 1,
      closed: false,
    });

    const tie = new Path({
      segments: [
        [CANVAS_CENTER - 4, 74],
        [CANVAS_CENTER - 2, 79],
        [CANVAS_CENTER - 5, 85],
        [CANVAS_CENTER + 5, 85],
        [CANVAS_CENTER + 2, 79],
        [CANVAS_CENTER + 4, 74],
      ],
      strokeColor: BORDER_COLOR,
      fillColor: BORDER_COLOR,
      strokeWidth: 1,
      closed: true,
    });

    super([leftShoulder, rightShoulder, tie]);
  }
}
